export default "__VITE_ASSET__mFSuSTp4__"